<template>
  <div v-show="!isRollover" class="top-navigation">
    <div class="container" v-show="false">
      <div class="left">
        <a href="https://www.porsche.com/usa/" target="_blank">
          <span>Porscheusa.com</span>
        </a>
        <a href="https://my.porsche.com/core/us/en_US/home" target="_blank">
          <span>My Porsche</span>
        </a>
      </div>

      <div class="right">
        <router-link
          v-if="isLoggedIn"
          to="/account"
          class="navbar-item"
          @click.native="toggleNav(true)"
        >
          <span class="navbar-link-title">
            {{ user.firstName }} {{ user.lastName }}
          </span>
          <span class="navbar-link-icon icon icon--contact"></span>
        </router-link>
        <router-link
          to="/account/my-policy"
          class="navbar-item"
          @click.native="toggleNav(true)"
        >
          <span class="navbar-link-title">My Policy</span>
        </router-link>
        <!--        <a-->
        <!--          v-if="isLoggedIn"-->
        <!--          class="navbar-item"-->
        <!--          @click.prevent="invokeLogOut()"-->
        <!--        >-->
        <!--          <span class="navbar-link-title"> Log Out </span>-->
        <!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AnchorRouterLink from 'vue-anchor-router-link';

export default {
  name: 'TopNavigation',
  components: {
    AnchorRouterLink
  },
  props: {},
  methods: {
    ...mapActions(['toggleNav', 'logOut']),
    ...mapMutations(['toggleLoader']),
    invokeLogOut: function() {
      this.toggleLoader({
        loaderText: 'Loading...'
      });
      this.logOut()
        .then(() => {
          this.toggleLoader();
          this.$router.push('/');
        })
        .catch(() => {
          this.toggleLoader();
        });
    }
  },
  computed: {
    ...mapGetters(['activeNav', 'user', 'policies', 'isLoggedIn', 'isRollover'])
  }
};
</script>

<style lang="scss" scoped>
.top-navigation {
  background-color: $surface;

  @media (max-width: 999px) {
    display: none;
  }
}

.container {
  height: 2.375rem;
}

.left {
  align-items: center;
  display: flex;
  flex-direction: row;
  float: left;
  height: 100%;
  margin-left: -0.9375rem;
  padding-left: 2%;

  & > * {
    flex: 0 1 auto;
  }
}

.right {
  align-items: center;
  display: flex;
  flex-direction: row;
  float: right;
  height: 100%;
  padding-right: 2%;
  margin-right: -0.9375rem;
}

a {
  align-items: center;
  color: #000000;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: row;
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
  position: relative;
  text-decoration: none;

  &.highlighted {
    background-color: $white;
  }

  &:hover {
    color: $red;
  }
}

span {
  padding-right: 0.9375rem;

  .left a:last-of-type & {
    padding-right: 0;
  }
}

.navbar-item {
  &:hover {
    background-color: transparent;
  }
}

.navbar-link-title {
  padding-right: 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
}

.navbar-link-icon {
  font-size: 1.25rem;
  margin-right: 0.3125rem;
  margin-left: 0.3125rem;
}
</style>
